import type { IphoneSmsConversation } from '@casetrace/shared';

type Service = IphoneSmsConversation['service'];

const SERVICE_STYLES: Record<Service, string> = {
  imessage: 'bg-accent/15 text-accent',
  sms: 'bg-success/10 text-success',
  mms: 'bg-success/10 text-success',
  rcs: 'bg-white/[0.07] text-[#8b8d9a]',
  unknown: 'bg-white/[0.07] text-[#5e6070]',
};

const SERVICE_LABELS: Record<Service, string> = {
  imessage: 'iMessage',
  sms: 'SMS',
  mms: 'MMS',
  rcs: 'RCS',
  unknown: 'Ukjent',
};

export function ServiceBadge({ service }: { readonly service: Service }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium ${SERVICE_STYLES[service]}`}
    >
      {SERVICE_LABELS[service]}
    </span>
  );
}
